<script setup>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
</script>
<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>เกมทั้งหมด</h6>
    </div>

    <div class="row"> <form role="form" >
     
     <div class="row">
       <div class="col-2">
         <base-input addon-left-icon="ni ni-calendar-grid-58">
   <flat-picker 
                @on-open="focus"
                @on-close="blur"
                :config="{allowInput: true}"
                class="form-control datepicker"
                placeholder="YYYY-MM-DD"
                v-model="startDate"
                >
   </flat-picker>
</base-input>
               </div>
               <div class="col-2">
         <base-input addon-left-icon="ni ni-calendar-grid-58">
   <flat-picker 
                @on-open="focus"
                @on-close="blur"
                :config="{allowInput: true}"
                class="form-control datepicker"
                placeholder="YYYY-MM-DD"
                v-model="endDate"
                >
   </flat-picker>
      </base-input>
               </div>
         <div class="col-2">
               <argon-input
                 id="name"
                 type="text"
                 placeholder="User"
                 aria-label="Name"
                 value="sd"
                 v-model="username"
               />
               </div>
               <div class="col-2">
               <argon-input
                 id="name"
                 type="text"
                 placeholder="Agent"
                 aria-label="Name"
                 value="sd"
                 v-model="agent"
               />
               </div>           
            
               <div class="text-center">
                 <argon-button
                   fullWidth
                   color="success"
                   variant="gradient"
                   class="my-4 mb-2"
                   @click="getData(startDate, endDate, agent, username)"
                   >ค้นหา</argon-button
                 >
               </div>
     </div>
         
    </form>
   </div>

    
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0" >
          <thead>
            <tr>
              <th v-for="column in columns" :key="column.id"  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">{{ column.name }}</th>
              
            </tr>
          </thead>
          <tbody v-if="displayedData.length > 0">
            <tr v-for="(item, index) in displayedData" :key="index">
              <slot :row="item">
                <td v-for="column in columns" :key="column.id" >{{ itemValue(item,
                  column.id, index) }}</td>
              </slot>
            </tr>
            <!--
            <tr>
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <img
                      src="../../assets/img/team-2.jpg"
                      class="avatar avatar-sm me-3"
                      alt="user1"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">John Michael</h6>
                    <p class="text-xs text-secondary mb-0">
                      john@creative-tim.com
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">Manager</p>
                <p class="text-xs text-secondary mb-0">Organization</p>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="badge badge-sm bg-gradient-success">Online</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold"
                  >23/04/18</span
                >
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Edit user"
                  >Edit</a
                >
              </td>
            </tr>
            -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import moment from "moment";

  
  export default {
   // components: { DatePick },
    name: 'l-table',
    // props: {
    //   columns: Array,
    //   data: Array
    // },
    data() {
      return {
        startRow: 0,
        rowsPerPage: 20,
        currentPage: 1,
        data: [],
        columns: [
        { id: 'no', name: 'No.' },
          { id: 'agent', name: 'agent' },
          { id: 'username', name: 'ชื่อผู้เล่น' },
          { id: 'updated_date', name: 'วันที่เล่น' },
          { id: 'updated_time', name: 'เวลาที่เล่น' },
          { id: 'play_status_id', name: 'สถานะ' },
          { id: 'bet_amount', name: 'เดิมพัน' },
          { id: 'win_loss', name: 'เงินได้เสีย' },
          { id: 'balance_credit', name: 'เงินคงเหลือ' },
          { id: 'mode', name: 'โหมด' }
        ],
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        agent: '',
        username: '',
        isLoading: false,
        allBet: 0,
        allWinLoss: 0,
        agentList: []
      }
    },
    created() {
      this.getData(this.startDate, this.endDate, this.agent, this.username)
    },
    computed: {
  
      filteredData() {
        return this.data.filter(item => this.columns.some(column => this.hasValue(item, column.id)))
      },
      displayedData() {
        return this.filteredData.slice(this.startRow, this.startRow + this.rowsPerPage)
      },
      totalPages() {
        return Math.ceil(this.filteredData.length / this.rowsPerPage)
      }
    },
    methods: {
      calculateSum(array, property) {
        const total = array.reduce((accumulator, object) => {
          return accumulator + Number(object[property]);
        }, 0);
  
        return total;
      },
      getData(startDate, endDate, agent, username ) {
        this.isLoading = true
        if (agent != '' && username == '') {
          axios
            .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/xmas/${startDate}/${endDate}`, { agent })
            // .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/warrior/${startDate}/${endDate}`, { agent })
            .then((response) => {
  
              // JSON responses are automatically parsed.
              this.data = response.data.data.list;
              this.agentList = response.data.data.agent
              this.allBet =  this.calculateSum(this.data.filter(bet => bet.is_freespin == 0), 'bet_amount')
              this.allWinLoss = this.calculateSum(this.data, 'win_loss')
              this.isLoading = false
            })
            .catch((e) => {
              console.log(e);
              this.isLoading = false
            });
        } else if (username != '' && agent == '') {
          axios
            .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/xmas/${startDate}/${endDate}`, { username })
            // .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/warrior/${startDate}/${endDate}`, { username })
            .then((response) => {
  
              // JSON responses are automatically parsed.
              this.data = response.data.data.list;
              this.agentList = response.data.data.agent
              this.allBet =  this.calculateSum(this.data.filter(bet => bet.is_freespin == 0), 'bet_amount')
              this.allWinLoss = this.calculateSum(this.data, 'win_loss')
              this.isLoading = false
            })
            .catch((e) => {
              console.log(e);
              this.isLoading = false
            });
        } else if (agent != '' && username != '') {
          axios
            .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/xmas/${startDate}/${endDate}`, { agent, username })
            // .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/warrior/${startDate}/${endDate}`, { agent, username })
  
            .then((response) => {
  
              // JSON responses are automatically parsed.
              this.data = response.data.data.list;
              this.agentList = response.data.data.agent
              this.allBet =  this.calculateSum(this.data.filter(bet => bet.is_freespin == 0), 'bet_amount')
              this.allWinLoss = this.calculateSum(this.data, 'win_loss')
              this.isLoading = false
            })
            .catch((e) => {
              console.log(e);
              this.isLoading = false
            });
        } else {
          axios
            .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/xmas/${startDate}/${endDate}`)
            // .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/warrior/${startDate}/${endDate}`)
            .then((response) => {
  
              // JSON responses are automatically parsed.
              this.data = response.data.data.list;
              this.agentList = response.data.data.agent
              this.allBet =  this.calculateSum(this.data.filter(bet => bet.is_freespin == 0), 'bet_amount')
              this.allWinLoss = this.calculateSum(this.data, 'win_loss')
              this.isLoading = false
            })
            .catch((e) => {
              console.log(e);
              this.isLoading = false
            });
        }
        this.currentPage = 1
      this.startRow = 0
      },
      hasValue(item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue(item, column, index) {
        if (column == 'no') {
          return index + 1 + this.startRow
        } else if (column == 'play_status_id') {
          if (item[column.toLowerCase()] == 1) {
            return 'ชนะ'
          } else if (item[column.toLowerCase()] == 2) {
            return 'เสมอ'
          } else {
            return 'แพ้'
          }
        } else if (column == 'mode' ) {
          if (item['is_feature_buy'] == 1) {
            return 'ซื้อฟีเจอร์'
          } else if (item['is_scatter'] == 1) {
            return 'เข้า scatter'
          } else if (item['is_freespin'] == 1) {
            return 'โบนัส'
          } else {
            return 'ปกติ'
          }
        } else {
          return item[column.toLowerCase()]
        }
      },
      previousPage() {
        if (this.startRow >= this.rowsPerPage) {
          this.startRow -= this.rowsPerPage
          this.currentPage--
        }
      },
      nextPage() {
        if (this.startRow + this.rowsPerPage < this.filteredData.length) {
          this.startRow += this.rowsPerPage
          this.currentPage++
        }
      },
      goToPage(page) {
        this.startRow = (page - 1) * this.rowsPerPage
        this.currentPage = page
      }
    }
  }
  </script>